module.exports = __webpack_public_path__ + "img/sus_reasonable_and_responsible.7867e92c.png";